<script>
  import { t9n } from '../lib/translate';
  import { TS } from '../config/translation-keys';
  import session from '../lib/session';
  import { onMount } from 'svelte';

  let currency;
  let earned;
  let history;

  const set_hexa_val = (index, hexa_val) => {
    let num = 0;
    let start = null;
    let duration = 500;

    const step = current_time => {
      if (!start) start = current_time;
      let elapsed_time = current_time - start;
      if (elapsed_time < duration) {
        num = Math.floor(hexa_val * (elapsed_time / duration));
        set_hexa_svg(index, num);
        window.requestAnimationFrame(step);
      } else {
        set_hexa_svg(index, hexa_val);
      }
    };

    window.requestAnimationFrame(step);
  };


  const set_hexa_svg = (index, num) => {
    let svg_x;
    let svg_num = document.getElementById('svg-num-' + index);

    if (svg_num) {
      svg_num.innerHTML = num ? num.toString() : '0';
      if (svg_x) {
        svg_num.setAttribute('x', svg_x);
      }
    }
  };

  const init_hexa_values_worker = () => {
    set_hexa_val(0, $session.user.stats.amount_earned.toFixed(0));
  };

  onMount(() => {
    earned = t9n(TS.HOME_HEXA_AMOUNT);
    history = t9n(TS.TABLE_CHIP_HIST);
    init_hexa_values_worker();
  });

  $: if (!!$session.merchant) {
    currency = $session.merchant.currency_sign;
  }

</script>

<div style='text-align: center'>
  <h1 class="mdc-typography--headline5" style="margin-top: 25px; text-align: center">
    {earned} ({currency}):
  </h1>
  <svg>
    <text
      id={'svg-num-0'}
      x="50%"
      y="80"
      font-family="Roboto"
      class="svg-num fade-in"
      text-anchor="middle">
      0
    </text>
  </svg>
  <div style="margin-top: 0px; text-align: center">
    <a
      data-link={true}
      href={'/orders?group=3&workerearning=true'}
      data-cy="open_pp_button"
      style="margin-right: 0px; padding-left: 18px; padding-right: 18px;"
      class="mdc-button mdc-button--raised">
      {history}
    </a>
  </div>
</div>

<style>
    .svg-num {
        font-family: Roboto, Arial;
        fill: black;
        font-size: 40pt;
    }
</style>